import actionTypes from '../../../../actions/Ui/Views/Market/actionTypes';

const initialState = {
  isLoading: false,
  isLoadingStates: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case actionTypes.LOADING:
      return {
        ...state,
        isLoading: true,
      };
    case actionTypes.LOADED:
      return {
        ...state,
        isLoading: false,
      };
    case actionTypes.LOADING_STATES:
      return {
        ...state,
        isLoadingStates: true,
      };
    case actionTypes.LOADED_STATES:
      return {
        ...state,
        isLoadingStates: false,
      };
    default:
      return state;
  }
}
